import React from 'react';
import Key from '../Key';
import ChartDetails from '../ChartDetails';
import * as d3 from '../../../libraries/d3';
import ToolTipWrapper from '../ToolTipDisplays/ToolTipPopover';

export default class VerticalBarChartWrapper extends React.Component {
  constructor(props) {
    super(props);
      this.state = {
        displayTooltip: false,
      };
  };

  render() {
    return (
      <div className="row">
        <div className="chart-wrapper col-md" >
          {
            !this.props.loading && this.props.data && this.props.data.length
              ?
              <div className="tt-svg-wrapper">
                {
                  this.state.displayTooltip
                  ?
                  <ToolTipWrapper
                    toolTipDetails={this.props.toolTipDetails}
                    date_format={this.props.date_format}
                    report_details={this.props.report_details}
                    closeToolTip={this.closeToolTip}
                    dimensions={this.props.dimensions}
                    onToggleDataSource={this.props.onToggleDataSource}
                  />
                  :
                  null
                }
                {/* <div style={{ width: '95%' }}> */}
                <svg id={`${this.props.report_details.chart_type.name}-${this.props.report_details.id}`} className="bar-chart" onClick={this.openToolTip}>
                    <ChartDetails
                      data={this.props.data}
                      report_details={this.props.report_details}
                      dimensions={this.props.dimensions}
                      yMaxMinDetailndValue={this.minMaxCheck()}
                      xAxisDetail={this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis')}
                      yAxisDetails={this.getYDetails()}
                      date_format={this.props.date_format}
                      onClickToolTip={this.props.onClickToolTip}
                    />
                  </svg>
                {/* </div> */}
              </div>
              :
              null
          }
          {/* <HiddenPreviewPopover targetId={this.props.report_details.id} model_type={'chart_tool_tip'} classes={this.props.columnId ? "popover-chart-tool-tip-embeded" : "popover-chart-tool-tip-modal"} position={this.props.columnId ? 'bottom' : 'top'} popoverVisible={this.props.toolTipDetails} date_format={this.props.date_format} chartType={this.props.report_details.chart_type.name} report_details={this.props.report_details} /> */}
        </div>
        {/* <Key
          dimensions={this.props.dimensions}
          dataDetails={this.getYDetails()}
        /> */}
      </div>
    );
  };

  minMaxCheck(){
    var minMax = this.yMaxMinDetailndValue()
    if (minMax.min > 0 && minMax.max > 0){
      minMax.min = 0;
    } else if (minMax.min < 0 && minMax.max < 0) {
      minMax.max = 0;
    };
    return minMax;
  };

  yMaxMinDetailndValue() {
    var yDataDetails = []
    var activeYdetails = this.getYDetails();

    activeYdetails.forEach(detail => yDataDetails.push(detail))
    if (yDataDetails && yDataDetails.length) {
      return yDataDetails.reduce((acc, detail) => {
        var detailMaxMin = d3.extent(this.props.data, d => {
          if (detail.data_type === 'percent') {
            return parseFloat(d[detail.data_column_name])
          } else {
            return parseInt(d[detail.data_column_name])
          }
        })
        if (!acc.max && !acc.min && !acc.minDataDetail && !acc.maxDataDetail) {
          acc = {
            minDataDetail: detail,
            maxDataDetail: detail,
            min: detail.data_type === 'percent' ? parseFloat(detailMaxMin[0]) * 100 : parseInt(detailMaxMin[0]),
            max: detail.data_type === 'percent' ? parseFloat(detailMaxMin[1]) * 100 : parseInt(detailMaxMin[1]),
          };
        } else {
          acc = {
            minDataDetail: acc.min > parseInt(detailMaxMin[0]) ? detail : acc.minDataDetail,
            maxDataDetail: acc.max < parseInt(detailMaxMin[1]) ? detail : acc.maxDataDetail,
            min: acc.min > parseInt(detailMaxMin[0]) ? (detail.data_type === 'percent' ? parseFloat(detailMaxMin[0]) * 100 : parseInt(detailMaxMin[0])) : acc.min,
            max: acc.max < parseInt(detailMaxMin[1]) ? (detail.data_type === 'percent' ? parseFloat(detailMaxMin[1]) * 100 : parseInt(detailMaxMin[1])) : acc.max,
          };
        };
        return acc
      }, {});
    } else {
      return { min: 0, max: 100 }
    };
  };

  getYDetails() {
    var yDetails = this.props.report_details.data_details.filter(detail => detail.chart_element === 'y-axis');
    if (this.props.includeYOY) {
      var copyDetails = yDetails.slice(0);
      copyDetails.forEach((detail) => {
        var copyDetail = Object.assign({}, detail);
        copyDetail.data_column_name = copyDetail.data_column_name + '_yoy';
        copyDetail.id = copyDetail.id + '_yoy';
        copyDetail.yoy = true;
        yDetails.push(copyDetail);
      })
    };
    return yDetails;
  };

  openToolTip = () => {
    this.setState({ displayTooltip: !this.state.displayTooltip });
  };

  closeToolTip = () => {
    this.setState({ displayTooltip: false })
  };

};